"use strict";
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.3.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var Client = /** @class */ (function () {
    function Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param channelId channelId
     * @param userId a user identification
     * @param topicId a topic identification
     * @param limit (optional) limit the results
     * @param beforeBrickId (optional) get brick befor a give brick id
     * @return Bricks created by the Event
     */
    Client.prototype.getBricks = function (channelId, userId, topicId, limit, beforeBrickId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/channels/{channelId}/users/{userId}/topics/{topicId}/bricks?";
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (topicId === undefined || topicId === null)
            throw new Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (beforeBrickId === null)
            throw new Error("The parameter 'beforeBrickId' cannot be null.");
        else if (beforeBrickId !== undefined)
            url_ += "beforeBrickId=" + encodeURIComponent("" + beforeBrickId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetBricks(_response);
        });
    };
    Client.prototype.processGetBricks = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                    var item = resultData200_1[_i];
                    result200.push(Brick.fromJS(item));
                }
            }
            return result200;
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ApiError.fromJS(resultData400);
            return throwException("Validation Error", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ApiError.fromJS(resultData401);
            return throwException("ApiError", status, _responseText, _headers, result401);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param channelId channelId
     * @param userId a user identification
     * @param topicId a topic identification
     * @return Bricks created by the Event
     */
    Client.prototype.processEvent = function (channelId, userId, topicId, body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/channels/{channelId}/users/{userId}/topics/{topicId}/events";
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (topicId === undefined || topicId === null)
            throw new Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProcessEvent(_response);
        });
    };
    Client.prototype.processProcessEvent = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                    var item = resultData200_2[_i];
                    result200.push(Brick.fromJS(item));
                }
            }
            return result200;
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ApiError.fromJS(resultData400);
            return throwException("Validation Error", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            var _responseText = response.data;
            var result401 = null;
            var resultData401 = _responseText;
            result401 = ApiError.fromJS(resultData401);
            return throwException("ApiError", status, _responseText, _headers, result401);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param channelId channelId
     * @param apiSecret (optional) ApiSecret
     * @return a access token
     */
    Client.prototype.login = function (channelId, apiSecret, body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/channels/{channelId}/login";
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "ApiSecret": apiSecret !== undefined && apiSecret !== null ? "" + apiSecret : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLogin(_response);
        });
    };
    Client.prototype.processLogin = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = Token.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ApiError.fromJS(resultData400);
            return throwException("Validation Error", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param channelId channelId
     * @return session object
     */
    Client.prototype.session = function (channelId, body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/channels/{channelId}/session";
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSession(_response);
        });
    };
    Client.prototype.processSession = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = SessionData.fromJS(resultData200);
            return result200;
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ApiError.fromJS(resultData400);
            return throwException("Validation Error", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param channelId channelId
     * @return openapi.json
     */
    Client.prototype.getChannelOpenApiJson = function (channelId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v1/channels/{channelId}/openapi.json";
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetChannelOpenApiJson(_response);
        });
    };
    Client.prototype.processGetChannelOpenApiJson = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Client;
}());
exports.Client = Client;
var Event = /** @class */ (function () {
    function Event(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Event.prototype.init = function (_data) {
        if (_data) {
            this.eventsource = _data["eventsource"];
            this.action = _data["action"];
            this.owner = _data["owner"];
            this.topic = _data["topic"];
            this.channel = _data["channel"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            this.name = _data["name"];
            if (Array.isArray(_data["appliedDsgvoDataPrivacyRules"])) {
                this.appliedDsgvoDataPrivacyRules = [];
                for (var _i = 0, _a = _data["appliedDsgvoDataPrivacyRules"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.appliedDsgvoDataPrivacyRules.push(item);
                }
            }
            this.payload = _data["payload"] ? Payload.fromJS(_data["payload"]) : undefined;
            this.content = _data["content"] ? Content.fromJS(_data["content"]) : undefined;
            this.scope = _data["scope"];
            this.tpKey = _data["tpKey"];
            if (Array.isArray(_data["secondaryIds"])) {
                this.secondaryIds = [];
                for (var _b = 0, _c = _data["secondaryIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.secondaryIds.push(item);
                }
            }
            this.options = _data["options"];
            this.text = _data["text"];
            if (Array.isArray(_data["suggestedOptions"])) {
                this.suggestedOptions = [];
                for (var _d = 0, _e = _data["suggestedOptions"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.suggestedOptions.push(SuggestedOptions.fromJS(item));
                }
            }
            this.nodeItemSourceId = _data["nodeItemSourceId"];
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    };
    Event.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Event();
        result.init(data);
        return result;
    };
    Event.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eventsource"] = this.eventsource;
        data["action"] = this.action;
        data["owner"] = this.owner;
        data["topic"] = this.topic;
        data["channel"] = this.channel;
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        data["name"] = this.name;
        if (Array.isArray(this.appliedDsgvoDataPrivacyRules)) {
            data["appliedDsgvoDataPrivacyRules"] = [];
            for (var _i = 0, _a = this.appliedDsgvoDataPrivacyRules; _i < _a.length; _i++) {
                var item = _a[_i];
                data["appliedDsgvoDataPrivacyRules"].push(item);
            }
        }
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        data["content"] = this.content ? this.content.toJSON() : undefined;
        data["scope"] = this.scope;
        data["tpKey"] = this.tpKey;
        if (Array.isArray(this.secondaryIds)) {
            data["secondaryIds"] = [];
            for (var _b = 0, _c = this.secondaryIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["secondaryIds"].push(item);
            }
        }
        data["options"] = this.options;
        data["text"] = this.text;
        if (Array.isArray(this.suggestedOptions)) {
            data["suggestedOptions"] = [];
            for (var _d = 0, _e = this.suggestedOptions; _d < _e.length; _d++) {
                var item = _e[_d];
                data["suggestedOptions"].push(item.toJSON());
            }
        }
        data["nodeItemSourceId"] = this.nodeItemSourceId;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    };
    return Event;
}());
exports.Event = Event;
var Login = /** @class */ (function () {
    function Login(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.isAnonym = true;
        }
    }
    Login.prototype.init = function (_data) {
        if (_data) {
            this.isAnonym = _data["isAnonym"] !== undefined ? _data["isAnonym"] : true;
            this.passwordLessToken = _data["passwordLessToken"];
        }
    };
    Login.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Login();
        result.init(data);
        return result;
    };
    Login.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isAnonym"] = this.isAnonym;
        data["passwordLessToken"] = this.passwordLessToken;
        return data;
    };
    return Login;
}());
exports.Login = Login;
var Token = /** @class */ (function () {
    function Token(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Token.prototype.init = function (_data) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.token_type = _data["token_type"];
            this.expires_in = _data["expires_in"];
            this.userID = _data["userID"];
        }
    };
    Token.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Token();
        result.init(data);
        return result;
    };
    Token.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["token_type"] = this.token_type;
        data["expires_in"] = this.expires_in;
        data["userID"] = this.userID;
        return data;
    };
    return Token;
}());
exports.Token = Token;
var SessionBody = /** @class */ (function () {
    function SessionBody(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SessionBody.prototype.init = function (_data) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["secondaryIds"])) {
                this.secondaryIds = [];
                for (var _i = 0, _a = _data["secondaryIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.secondaryIds.push(item);
                }
            }
        }
    };
    SessionBody.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SessionBody();
        result.init(data);
        return result;
    };
    SessionBody.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.secondaryIds)) {
            data["secondaryIds"] = [];
            for (var _i = 0, _a = this.secondaryIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["secondaryIds"].push(item);
            }
        }
        return data;
    };
    return SessionBody;
}());
exports.SessionBody = SessionBody;
var SessionData = /** @class */ (function () {
    function SessionData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SessionData.prototype.init = function (_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.topicId = _data["topicId"];
        }
    };
    SessionData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SessionData();
        result.init(data);
        return result;
    };
    SessionData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["topicId"] = this.topicId;
        return data;
    };
    return SessionData;
}());
exports.SessionData = SessionData;
var User = /** @class */ (function () {
    function User(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.policy = "anonymUser";
            this.isAnonym = true;
        }
    }
    User.prototype.init = function (_data) {
        if (_data) {
            this.secondary = _data["secondary"];
            if (Array.isArray(_data["secondaryIds"])) {
                this.secondaryIds = [];
                for (var _i = 0, _a = _data["secondaryIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.secondaryIds.push(item);
                }
            }
            this.policy = _data["policy"] !== undefined ? _data["policy"] : "anonymUser";
            this.isAnonym = _data["isAnonym"] !== undefined ? _data["isAnonym"] : true;
            if (Array.isArray(_data["appliedDsgvoDataPrivacyRules"])) {
                this.appliedDsgvoDataPrivacyRules = [];
                for (var _b = 0, _c = _data["appliedDsgvoDataPrivacyRules"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.appliedDsgvoDataPrivacyRules.push(item);
                }
            }
            this.username = _data["username"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.channel = _data["channel"];
            this.secret = _data["secret"];
            this.lastLoginDate = _data["lastLoginDate"] ? new Date(_data["lastLoginDate"].toString()) : undefined;
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    };
    User.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new User();
        result.init(data);
        return result;
    };
    User.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["secondary"] = this.secondary;
        if (Array.isArray(this.secondaryIds)) {
            data["secondaryIds"] = [];
            for (var _i = 0, _a = this.secondaryIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["secondaryIds"].push(item);
            }
        }
        data["policy"] = this.policy;
        data["isAnonym"] = this.isAnonym;
        if (Array.isArray(this.appliedDsgvoDataPrivacyRules)) {
            data["appliedDsgvoDataPrivacyRules"] = [];
            for (var _b = 0, _c = this.appliedDsgvoDataPrivacyRules; _b < _c.length; _b++) {
                var item = _c[_b];
                data["appliedDsgvoDataPrivacyRules"].push(item);
            }
        }
        data["username"] = this.username;
        data["password"] = this.password;
        data["email"] = this.email;
        data["channel"] = this.channel;
        data["secret"] = this.secret;
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : undefined;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    };
    return User;
}());
exports.User = User;
var Brick = /** @class */ (function () {
    function Brick(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.creator = BrickCreator.Ai;
        }
    }
    Brick.prototype.init = function (_data) {
        if (_data) {
            this.creator = _data["creator"] !== undefined ? _data["creator"] : BrickCreator.Ai;
            this.content = _data["content"];
            this.owner = _data["owner"];
            this.topic = _data["topic"];
            this.channel = _data["channel"];
            this.scene = _data["scene"] ? Scene.fromJS(_data["scene"]) : undefined;
            if (Array.isArray(_data["appliedDsgvoDataPrivacyRules"])) {
                this.appliedDsgvoDataPrivacyRules = [];
                for (var _i = 0, _a = _data["appliedDsgvoDataPrivacyRules"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.appliedDsgvoDataPrivacyRules.push(item);
                }
            }
            if (Array.isArray(_data["suggestedOptions"])) {
                this.suggestedOptions = [];
                for (var _b = 0, _c = _data["suggestedOptions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.suggestedOptions.push(SuggestedOptions2.fromJS(item));
                }
            }
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    };
    Brick.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Brick();
        result.init(data);
        return result;
    };
    Brick.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["creator"] = this.creator;
        data["content"] = this.content;
        data["owner"] = this.owner;
        data["topic"] = this.topic;
        data["channel"] = this.channel;
        data["scene"] = this.scene ? this.scene.toJSON() : undefined;
        if (Array.isArray(this.appliedDsgvoDataPrivacyRules)) {
            data["appliedDsgvoDataPrivacyRules"] = [];
            for (var _i = 0, _a = this.appliedDsgvoDataPrivacyRules; _i < _a.length; _i++) {
                var item = _a[_i];
                data["appliedDsgvoDataPrivacyRules"].push(item);
            }
        }
        if (Array.isArray(this.suggestedOptions)) {
            data["suggestedOptions"] = [];
            for (var _b = 0, _c = this.suggestedOptions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["suggestedOptions"].push(item.toJSON());
            }
        }
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    };
    return Brick;
}());
exports.Brick = Brick;
var ApiError = /** @class */ (function () {
    function ApiError(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApiError.prototype.init = function (_data) {
        if (_data) {
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : undefined;
        }
    };
    ApiError.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApiError();
        result.init(data);
        return result;
    };
    ApiError.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : undefined;
        return data;
    };
    return ApiError;
}());
exports.ApiError = ApiError;
var Payload = /** @class */ (function () {
    function Payload(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Payload.prototype.init = function (_data) {
        if (_data) {
            this.eventCategory = _data["eventCategory"];
            this.eventAction = _data["eventAction"];
            this.source = _data["source"];
            this.item = _data["item"];
            this.actionComponent = _data["actionComponent"];
        }
    };
    Payload.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Payload();
        result.init(data);
        return result;
    };
    Payload.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eventCategory"] = this.eventCategory;
        data["eventAction"] = this.eventAction;
        data["source"] = this.source;
        data["item"] = this.item;
        data["actionComponent"] = this.actionComponent;
        return data;
    };
    return Payload;
}());
exports.Payload = Payload;
var Content = /** @class */ (function () {
    function Content(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Content.prototype.init = function (_data) {
        if (_data) {
            this.schemaRef = _data["schemaRef"];
            this.data = _data["data"];
        }
    };
    Content.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Content();
        result.init(data);
        return result;
    };
    Content.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["schemaRef"] = this.schemaRef;
        data["data"] = this.data;
        return data;
    };
    return Content;
}());
exports.Content = Content;
var EventScope;
(function (EventScope) {
    EventScope["Event"] = "event";
    EventScope["Session"] = "session";
    EventScope["User"] = "user";
})(EventScope = exports.EventScope || (exports.EventScope = {}));
var SuggestedOptions = /** @class */ (function () {
    function SuggestedOptions(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SuggestedOptions.prototype.init = function (_data) {
        if (_data) {
            this._id = _data["_id"];
            this.name = _data["name"];
            this.event = _data["event"];
            this.data = _data["data"];
            this.score = _data["score"];
            if (Array.isArray(_data["actors"])) {
                this.actors = [];
                for (var _i = 0, _a = _data["actors"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.actors.push(item);
                }
            }
            this.dataStoreTransactions = _data["dataStoreTransactions"] ? DataStoreTransactions.fromJS(_data["dataStoreTransactions"]) : undefined;
            if (Array.isArray(_data["microIntends"])) {
                this.microIntends = [];
                for (var _b = 0, _c = _data["microIntends"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.microIntends.push(item);
                }
            }
            if (Array.isArray(_data["triggedByMicroIntends"])) {
                this.triggedByMicroIntends = [];
                for (var _d = 0, _e = _data["triggedByMicroIntends"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.triggedByMicroIntends.push(item);
                }
            }
            this.stateEvent = _data["stateEvent"];
            this.clickIds = _data["clickIds"];
            this.content = _data["content"] ? Content2.fromJS(_data["content"]) : undefined;
        }
    };
    SuggestedOptions.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SuggestedOptions();
        result.init(data);
        return result;
    };
    SuggestedOptions.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["_id"] = this._id;
        data["name"] = this.name;
        data["event"] = this.event;
        data["data"] = this.data;
        data["score"] = this.score;
        if (Array.isArray(this.actors)) {
            data["actors"] = [];
            for (var _i = 0, _a = this.actors; _i < _a.length; _i++) {
                var item = _a[_i];
                data["actors"].push(item);
            }
        }
        data["dataStoreTransactions"] = this.dataStoreTransactions ? this.dataStoreTransactions.toJSON() : undefined;
        if (Array.isArray(this.microIntends)) {
            data["microIntends"] = [];
            for (var _b = 0, _c = this.microIntends; _b < _c.length; _b++) {
                var item = _c[_b];
                data["microIntends"].push(item);
            }
        }
        if (Array.isArray(this.triggedByMicroIntends)) {
            data["triggedByMicroIntends"] = [];
            for (var _d = 0, _e = this.triggedByMicroIntends; _d < _e.length; _d++) {
                var item = _e[_d];
                data["triggedByMicroIntends"].push(item);
            }
        }
        data["stateEvent"] = this.stateEvent;
        data["clickIds"] = this.clickIds;
        data["content"] = this.content ? this.content.toJSON() : undefined;
        return data;
    };
    return SuggestedOptions;
}());
exports.SuggestedOptions = SuggestedOptions;
var BrickCreator;
(function (BrickCreator) {
    BrickCreator["Ai"] = "ai";
    BrickCreator["Human"] = "human";
})(BrickCreator = exports.BrickCreator || (exports.BrickCreator = {}));
var Scene = /** @class */ (function () {
    function Scene(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.insertStart = 0;
            this.deleteCount = 0;
        }
    }
    Scene.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.square = _data["square"];
            this.insertStart = _data["insertStart"] !== undefined ? _data["insertStart"] : 0;
            this.deleteCount = _data["deleteCount"] !== undefined ? _data["deleteCount"] : 0;
        }
    };
    Scene.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Scene();
        result.init(data);
        return result;
    };
    Scene.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["square"] = this.square;
        data["insertStart"] = this.insertStart;
        data["deleteCount"] = this.deleteCount;
        return data;
    };
    return Scene;
}());
exports.Scene = Scene;
var SuggestedOptions2 = /** @class */ (function () {
    function SuggestedOptions2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SuggestedOptions2.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.groupId = _data["groupId"];
            this.content = _data["content"] ? Content3.fromJS(_data["content"]) : undefined;
            this.nodeItemSourceId = _data["nodeItemSourceId"];
            this._id = _data["_id"];
        }
    };
    SuggestedOptions2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SuggestedOptions2();
        result.init(data);
        return result;
    };
    SuggestedOptions2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["groupId"] = this.groupId;
        data["content"] = this.content ? this.content.toJSON() : undefined;
        data["nodeItemSourceId"] = this.nodeItemSourceId;
        data["_id"] = this._id;
        return data;
    };
    return SuggestedOptions2;
}());
exports.SuggestedOptions2 = SuggestedOptions2;
var ErrorDto = /** @class */ (function () {
    function ErrorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ErrorDto.prototype.init = function (_data) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [];
                for (var _i = 0, _a = _data["validationErrors"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationErrors.push(ValidationErrors.fromJS(item));
                }
            }
        }
    };
    ErrorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ErrorDto();
        result.init(data);
        return result;
    };
    ErrorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (var _i = 0, _a = this.validationErrors; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationErrors"].push(item.toJSON());
            }
        }
        return data;
    };
    return ErrorDto;
}());
exports.ErrorDto = ErrorDto;
var DataStoreTransactions = /** @class */ (function () {
    function DataStoreTransactions(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DataStoreTransactions.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["add"])) {
                this.add = [];
                for (var _i = 0, _a = _data["add"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.add.push(Add.fromJS(item));
                }
            }
            if (Array.isArray(_data["remove"])) {
                this.remove = [];
                for (var _b = 0, _c = _data["remove"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.remove.push(Remove.fromJS(item));
                }
            }
        }
    };
    DataStoreTransactions.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DataStoreTransactions();
        result.init(data);
        return result;
    };
    DataStoreTransactions.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.add)) {
            data["add"] = [];
            for (var _i = 0, _a = this.add; _i < _a.length; _i++) {
                var item = _a[_i];
                data["add"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.remove)) {
            data["remove"] = [];
            for (var _b = 0, _c = this.remove; _b < _c.length; _b++) {
                var item = _c[_b];
                data["remove"].push(item.toJSON());
            }
        }
        return data;
    };
    return DataStoreTransactions;
}());
exports.DataStoreTransactions = DataStoreTransactions;
var Content2 = /** @class */ (function () {
    function Content2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Content2.prototype.init = function (_data) {
        if (_data) {
            this.schemaRef = _data["schemaRef"];
            this.data = _data["data"];
        }
    };
    Content2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Content2();
        result.init(data);
        return result;
    };
    Content2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["schemaRef"] = this.schemaRef;
        data["data"] = this.data;
        return data;
    };
    return Content2;
}());
exports.Content2 = Content2;
var Content3 = /** @class */ (function () {
    function Content3(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Content3.prototype.init = function (_data) {
        if (_data) {
            this.schemaRef = _data["schemaRef"];
            this.data = _data["data"];
        }
    };
    Content3.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Content3();
        result.init(data);
        return result;
    };
    Content3.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["schemaRef"] = this.schemaRef;
        data["data"] = this.data;
        return data;
    };
    return Content3;
}());
exports.Content3 = Content3;
var ValidationErrors = /** @class */ (function () {
    function ValidationErrors(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidationErrors.prototype.init = function (_data) {
        if (_data) {
            this.message = _data["message"];
            this.kind = _data["kind"];
            this.path = _data["path"];
        }
    };
    ValidationErrors.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidationErrors();
        result.init(data);
        return result;
    };
    ValidationErrors.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["kind"] = this.kind;
        data["path"] = this.path;
        return data;
    };
    return ValidationErrors;
}());
exports.ValidationErrors = ValidationErrors;
var Add = /** @class */ (function () {
    function Add(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.source = AddSource.BaiCore;
        }
    }
    Add.prototype.init = function (_data) {
        if (_data) {
            this.key = _data["key"];
            this.path = _data["path"];
            this.value = _data["value"];
            this.ttl = _data["ttl"] ? Ttl.fromJS(_data["ttl"]) : undefined;
            this.source = _data["source"] !== undefined ? _data["source"] : AddSource.BaiCore;
            this._id = _data["_id"];
        }
    };
    Add.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Add();
        result.init(data);
        return result;
    };
    Add.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["path"] = this.path;
        data["value"] = this.value;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : undefined;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    };
    return Add;
}());
exports.Add = Add;
var Remove = /** @class */ (function () {
    function Remove(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.source = RemoveSource.BaiCore;
        }
    }
    Remove.prototype.init = function (_data) {
        if (_data) {
            this.key = _data["key"];
            this.path = _data["path"];
            this.value = _data["value"];
            this.ttl = _data["ttl"] ? Ttl2.fromJS(_data["ttl"]) : undefined;
            this.source = _data["source"] !== undefined ? _data["source"] : RemoveSource.BaiCore;
            this._id = _data["_id"];
        }
    };
    Remove.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Remove();
        result.init(data);
        return result;
    };
    Remove.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["path"] = this.path;
        data["value"] = this.value;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : undefined;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    };
    return Remove;
}());
exports.Remove = Remove;
var Ttl = /** @class */ (function () {
    function Ttl(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.unit = TtlUnit.Milliseconds;
        }
    }
    Ttl.prototype.init = function (_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.unit = _data["unit"] !== undefined ? _data["unit"] : TtlUnit.Milliseconds;
        }
    };
    Ttl.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Ttl();
        result.init(data);
        return result;
    };
    Ttl.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    };
    return Ttl;
}());
exports.Ttl = Ttl;
var AddSource;
(function (AddSource) {
    AddSource["SuggestedOption"] = "suggestedOption";
    AddSource["BaiCore"] = "baiCore";
    AddSource["CurrentState"] = "currentState";
    AddSource["DataStore"] = "dataStore";
})(AddSource = exports.AddSource || (exports.AddSource = {}));
var Ttl2 = /** @class */ (function () {
    function Ttl2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.unit = Ttl2Unit.Milliseconds;
        }
    }
    Ttl2.prototype.init = function (_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.unit = _data["unit"] !== undefined ? _data["unit"] : Ttl2Unit.Milliseconds;
        }
    };
    Ttl2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Ttl2();
        result.init(data);
        return result;
    };
    Ttl2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    };
    return Ttl2;
}());
exports.Ttl2 = Ttl2;
var RemoveSource;
(function (RemoveSource) {
    RemoveSource["SuggestedOption"] = "suggestedOption";
    RemoveSource["BaiCore"] = "baiCore";
    RemoveSource["CurrentState"] = "currentState";
    RemoveSource["DataStore"] = "dataStore";
})(RemoveSource = exports.RemoveSource || (exports.RemoveSource = {}));
var TtlUnit;
(function (TtlUnit) {
    TtlUnit["Milliseconds"] = "milliseconds";
    TtlUnit["Seconds"] = "seconds";
    TtlUnit["Minutes"] = "minutes";
    TtlUnit["Hours"] = "hours";
    TtlUnit["Days"] = "days";
    TtlUnit["Months"] = "months";
    TtlUnit["Years"] = "years";
})(TtlUnit = exports.TtlUnit || (exports.TtlUnit = {}));
var Ttl2Unit;
(function (Ttl2Unit) {
    Ttl2Unit["Milliseconds"] = "milliseconds";
    Ttl2Unit["Seconds"] = "seconds";
    Ttl2Unit["Minutes"] = "minutes";
    Ttl2Unit["Hours"] = "hours";
    Ttl2Unit["Days"] = "days";
    Ttl2Unit["Months"] = "months";
    Ttl2Unit["Years"] = "years";
})(Ttl2Unit = exports.Ttl2Unit || (exports.Ttl2Unit = {}));
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
//# sourceMappingURL=EventApiClient.js.map